<template>
    <div class="row">
        <div class="col-xs-12">
            <div class="filters_cnt">
                <filter-fullproperty @filterResults="filterResults" v-if="searchType !== 'quartos'" />
                <filter-rooms @filterResults="filterResults" v-else />
            </div>
            <div class="pull-right">
                <button v-if="location && view === 'list'" class="btn btn-icon btn-default waves-effect waves-light" @click="changeView()" type="button">
                    <i class="far fa-map"></i>
                    Ver Mapa
                </button>
                <button v-if="location && view === 'map'" class="btn btn-icon btn-default waves-effect waves-light" @click="changeView()" type="button">
                    <i class="fas fa-bars"></i>
                    Ver Lista
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import urlParams from '../mixins/url-params';
import FilterFullproperty from './../../components/search/filter-fullproperty.vue';
import FilterRooms from './../../components/search/filter-rooms.vue';
export default {
    mixins: [urlParams],
    components: { FilterFullproperty, FilterRooms },
    data: function () {
        return {};
    },
    computed: {
        view: function () {
            return this.$store.getters.getView;
        },
        location: function () {
            return this.$store.getters.getCitySlug;
        },
        searchType: function () {
            return this.$store.getters.getSearchType;
        },
        properties: function () {
            return this.$store.getters.getAds;
        },
    },
    methods: {
        filterResults() {
            this.$store.commit('setPage', 1);
            this.$store.dispatch('replaceUrl');
            this.$store.dispatch('filterResults');
            this.registerSearchEvent();
        },
        registerSearchEvent() {
            window.dataLayer.push({
                'event': 'search',
                'event_category': 'search_page',
                'event_label': 'search_results',
                'search_location': this.location,
                'search_type': 'list',
                'search_results': this.properties.length
            });
        },
        changeView() {
            let url = '/busca';
            if (this.view === 'list') {
                url = '/busca-mapa';
            }

            let type = this.$store.state.search_type;
            if (type != '' && typeof type != 'undefined')
                url = url + '/' + type;
            if (this.location != '' && typeof this.location != 'undefined')
                url = url + '/' + this.location;

            const districts = this.$store.getters.getSelectedDistricts;
            if (districts && districts.length) {
                url += `/${districts.join(',')}`;
            }

            const query = this.getUrlQuery(this.$store.getters.getActiveFilters, true);
            if (query) {
                url += `?${query}`;
            }

            location.href = url;
        },
    },
    created() {
        this.$store.dispatch('getFiltersData');
    },
    mounted() {
        $('.filter_item .dropdown-menu').click(function (e) {
            e.stopPropagation();
        });

        $('.filter_item').on('show.bs.dropdown', function(e) {
            var dropdown = $(e.target).find('.dropdown-menu');
            let pos = $(e.target).offset();
            dropdown.appendTo('body')
                .addClass('filter_open');

            let top = pos.top + 40;
            let left = pos.left;
            if (dropdown.hasClass('dropdown-menu-right')) {
                left += $(e.target).width() - dropdown.width() - 25;
            }

            dropdown.offset({
                top: top,
                left: left
            });

            $(this).on('hidden.bs.dropdown', function () {
                dropdown.appendTo(e.target).removeClass('filter_open');
            })
        });
    }
}
</script>

<style lang="scss">
.filters_cnt {
    position: relative;
    display: inline-block;
    width: calc(100% - 130px);
    overflow-x: auto;
}

#search_filter {
    width: 100%;
    white-space: nowrap;
    display: inline-block;
    height: auto;
    padding-bottom: 5px;
}
.filter_item {
    display: inline-block;
    margin-bottom: 5px;

    >button.btn {
        padding: 6px 8px;
    }

    .dropdown-menu {
        padding: 10px;
        transition: none;
    }
}

.dropdown-menu.filter_open {
    padding: 10px;
    display: block;
    transition: none;
}

.dropdown-districts {
    max-height: 320px;
    overflow-y: scroll;
    max-width: 100%;
    overflow-x: hidden;
}

#sort_by {
	.sort_button {
		width: auto !important;
	}

	.sort_button:hover, .sort_button:focus {
		text-decoration: none;
	}
}


div.order {
	width: 220px;
}

.search-tag {
	text-transform: none;
	font-size: 12px;
	display: inline-flex;
	align-items: center;
}

.search-tag i {
	font-style: normal;
	margin-left: 6px;
}

.overlay_filter {
	height: 100%;
	width: 0;
	position: fixed;
	z-index: 90000;
	top: 0;
	left: 0;
	background-color: #fff;
	overflow-x: hidden;
	transition: all 0.5s;
	border-right: solid 1px #f7f7f7;
	padding: 60px 0 0;

	.closebtn {
		position: absolute;
		top: 0;
		right: 25px;
		font-size: 36px;
		margin-left: 50px;
		color: #CCC;
	}

}

.overlay_filter.open {
	width: 300px;
	padding: 60px 15px 15px;
}

@media (max-width: 660px) {
    .dropdown-menu.filter_open {
        left: 50% !important;
        transform: translateX(-50%);
        min-width: 90vw;
        max-width: 95vw;
        right: auto !important;
    }
    .dropdown-menu {
        position: fixed !important;
        z-index: 9999;
    }
}
</style>
